document.addEventListener('DOMContentLoaded', function() {
  // Bind events to the "Change" buttons
  document.addEventListener('click', function(e) {
    const button = e.target.closest('.cart-item__change-warranty');
    if (!button) return;

    e.preventDefault();
    e.stopPropagation();

    handleChangeWarrantyClick(button);
  });

  function handleChangeWarrantyClick(button) {
    const currentCartItemId = button.dataset.productId;
    const currentLineItemUniqueId = button.dataset.lineItemUniqueId;
    const currentIndex = button.dataset.index;
    const lineItemId = button.dataset.lineItemId || currentCartItemId;

    if (!currentCartItemId || !currentLineItemUniqueId || !currentIndex || !lineItemId) {
      console.error('Missing dataset attributes', {
        productId: currentCartItemId,
        lineItemUniqueId: currentLineItemUniqueId,
        index: currentIndex,
        lineItemId,
      });
      showToast('Error: Invalid button configuration.', true);
      return;
    }

    const warrantyPopupId = `warrantyPopup-${lineItemId}-${currentLineItemUniqueId}`;
    const warrantyPopup = document.getElementById(warrantyPopupId);
    if (!warrantyPopup) {
      console.error(`${warrantyPopupId} not found. Please check the ID`);
      showToast('Error: Warranty popup not found.', true);
      return;
    }

    const currentWarrantyElement = button.closest('.cart-item__warranty')?.querySelector('input:checked');
    const currentWarranty = currentWarrantyElement?.value || '';

    const warrantyRadios = warrantyPopup.querySelectorAll(`.warranty-popup__items input[type="radio"]`);
    if (warrantyRadios.length === 0) {
      console.error(`warrantyRadios not found in popup`);
      showToast('Error: Warranty options not found.', true);
      return;
    }

    warrantyRadios.forEach(radio => (radio.checked = false));

    let foundMatch = false;
    warrantyRadios.forEach(radio => {
      if (currentWarranty && radio.value.toLowerCase() === currentWarranty.toLowerCase()) {
        radio.checked = true;
        foundMatch = true;
      }
    });

    if (!foundMatch) {
      const manufacturerWarrantyRadio = warrantyPopup.querySelector('.warranty-popup__items .default-option input');
      if (manufacturerWarrantyRadio) manufacturerWarrantyRadio.checked = true;
    }

    warrantyPopup.style.display = 'flex';
  }

  // Close popup buttons
  document.addEventListener('click', function (e) {
    const closeBtn = e.target.closest('.warranty-popup__close');
    if (closeBtn) {
      const popup = closeBtn.closest('.warranty-popup');
      if (popup) popup.style.display = 'none';
      document.querySelector('html').classList.remove('overflow-hidden');
    }
  });
});
